<template>
    <div class=" uk-background-muted " style="background: #004e9c !important;">
        <div class="uk-container ">
            <div>
                <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slideshow=" ratio: 10:5; animation: fade; autoplay: true; autoplay-interval: 3000">
                    <ul class="uk-slideshow-items">
                        <li >
                            <div  uk-grid>
                                <div class="uk-width-2-5@m">
                                    <div class="uk-padding-small@m" >
                                       <span class="uk-visible@m">
                                            <br><br>
                                        </span>
                                        <h1 class="uk-visible@m" style="color: white;">Aeorion SMS</h1>
                                        <h4 class="uk-hidden@m" style="color: white;">Aeorion SMS</h4>
                                        <h3 class="uk-text-muted uk-margin-remove-top uk-visible@m" > Want to make your whole classroom virtual well Aeorion SMS is the solution that you are looking that you need.</h3>
                                        <h5 class="uk-text-muted uk-margin-remove-top uk-hidden@m" > Want to make your whole classroom virtual well Aeorion SMS is the solution that you are looking that you need.</h5>

                                        <div class="uk-text-left">
                                            <router-link to="/contactus" class="uk-button uk-button-default  uk-margin-small-right uk-text-capitalize ">Request Demo</router-link>
                                            <span class="uk-hidden@s"><br><br></span>
                                            <router-link to="/productservices" class="uk-button uk-button-default  uk-text-capitalize"
                                                         style="color: #004e9c !important; background-color: white;">Learn More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div  class="uk-width-1-1 uk-visible@m uk-width-3-5@m">
                                    <div class="">
                                        <span class="uk-visible@m">
                                            <br><br>
                                        </span>
                                        <img src="../../assets/bg2.jpeg" alt="" class="" >
                                    </div>
                                </div>
                            </div>

                            <!--<div class="uk-position-cover uk-position-small uk-text-center uk-light uk-overlay uk-overlay-primary"
                                 style="margin: -15px !important; background: rgba(51,51,51, 0.6)"
                            >
                                <h2 class="uk-margin-remove uk-align-center">Center</h2>
                                <p class="uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>-->
                        </li>
                        <li >
                            <div  uk-grid>
                                <div  class="uk-width-1-1 uk-visible@m uk-width-3-5@m">
                                    <div class="">
                                        <span class="uk-visible@m">
                                            <br><br>
                                        </span>
                                        <img src="../../assets/bg1.jpg" alt="" class="" >
                                    </div>
                                </div>
                                <div class="uk-width-2-5@m">
                                    <div class="uk-padding-small@m">
                                        <span class="uk-visible@m">
                                            <br><br>
                                        </span>
                                        <h1 class="uk-visible@m" style="color: white; ">Aeorion K-12</h1>
                                        <h4 class="uk-hidden@m" style="color: white; ">Aeorion K-12</h4>
                                        <h3 class="uk-text-muted uk-margin-remove-top uk-visible@m" >Need to fully manage your high school our K-12 system will make this a breeze to do</h3>
                                        <h5 class="uk-text-muted uk-margin-remove-top uk-hidden@m" >Need to fully manage your high school our K-12 system will make this a breeze to do</h5>
                                        <div class="uk-text-left">
                                            <router-link to="/contactus" class="uk-button uk-button-default  uk-margin-small-right uk-text-capitalize ">Request Demo</router-link>
                                            <span class="uk-hidden@s"><br><br></span>
                                            <router-link to="/productservices" class="uk-button uk-button-default  uk-text-capitalize"
                                                         style="color: #004e9c !important; background-color: white;">Learn More</router-link>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </li>
                    </ul>
                    <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
                    <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>

                </div>
            </div>
            <!--<div class="uk-child-width-1-1@m" uk-grid>

                &lt;!&ndash;<div>
                    <img src="/bg.jpg"  alt="" style="border-radius: 15px;">
                </div>&ndash;&gt;
            </div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "starter"
    }
</script>

<style scoped>
    a{
        font-size: large;
    }
</style>